import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "components/ui/card";
import React from "react";
import { useTheme } from "@/components/theme-provider";
import { ReactQueryErrorWrapper } from "components/shared/react-query-error-wrapper";
import { UsageGraphProps } from "./types";
import { useChartConfig } from "./use-chart-config";

export const UsageGraph: React.FC<UsageGraphProps> = (props) => {
  const { resolvedTheme } = useTheme();
  const chartRef = useChartConfig(props, resolvedTheme === "dark");

  return (
    <Card className="flex flex-col">
      <CardHeader>
        <CardTitle>Credit Usage</CardTitle>
        {props.subheader && (
          <CardDescription>{props.subheader}</CardDescription>
        )}
      </CardHeader>
      <CardContent className="h-full w-full">
        <ReactQueryErrorWrapper queries={[props.usageQuery]} mutations={[]} />
        {props.isSuccess && (
          <div ref={chartRef} style={{ height: 500, width: "100%" }} />
        )}
      </CardContent>
    </Card>
  );
};
